import { render, staticRenderFns } from "./ScreenConfiguracionVerificacion.vue?vue&type=template&id=55c3b1bc&scoped=true"
import script from "./ScreenConfiguracionVerificacion.vue?vue&type=script&lang=js"
export * from "./ScreenConfiguracionVerificacion.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfiguracionVerificacion.vue?vue&type=style&index=0&id=55c3b1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3b1bc",
  null
  
)

export default component.exports